import { render, staticRenderFns } from "./libraryQuestion.vue?vue&type=template&id=454eade0&"
import script from "./libraryQuestion.vue?vue&type=script&lang=js&"
export * from "./libraryQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports